import { User } from "./account"

export const cookieAuth = 'user_token'
export const Roles = {
    admin: 'admin',
    user: 'user'
}

export type LoginRes = {
    id: string
    username: string
    email: string
    fullName: string
    avatar: string
    token: string
} & User

export type RegisterRes = {
    id: string
    fullName: string
    userName: string
    email: string
    emailToken: string
}
